export const ERROR_MESSAGES = {
  callbackNeedToBeFunction: 'Callback needs to be a function!',
};
